export default "/images/204d9930ec39a8ffe004c1990c2ef4d3.avif";